<template>
  <div class="peoplechoice">
    <Header :title="$t('m.DualStreamFunction')"></Header>
    <div class="bgc3" :class="login=='mobile'?'serch':'serch_wechat'">
      <span style="float:left">
        <span class="serchbox">
          <Icon type="ios-search"></Icon>
          <input
            @input="search"
            class="searchinput"
            :placeholder="$t('m.PlsenterTerminalName')"
            type="text"
            v-model="searchcontent"
          />
        </span>
        <!-- <span>搜索</span> -->
      </span>
    </div>
    <!-- <div class="choice">{{choice}}</div> -->
    <div :class="login=='mobile'?'main':'main_wechat'">
      <RadioGroup v-model="avalibleterminal" class="radio_wrap" @on-change="Radioselect">
        <div :key="index" class="mainitem" v-for="(item,index) in array">
          <div :index="item.key" class="title spebgc">{{item.key}}</div>
          <div class="content">
            <div :key="mindex" class="contentitem" v-for="(mitem,mindex) in item.array">
              <Radio :label="JSON.stringify(mitem)">
                <span class="headerpicwarp">
                  <Icon type="ios-contacts" />
                </span>
                <span
                  style="line-height:0.41rem;width:1.3rem;display:inline-block;margin-left:0.05rem;font-size:0.14rem; word-break:keep-all;white-space:nowrap;text-overflow:ellipsis"
                >{{mitem.partyNameInWeMeet}}</span>
              </Radio>
            </div>
          </div>
        </div>
      </RadioGroup>
    </div>
    <div @click="sure" class="bottom bgc">{{$t('m.OKBtn')}}</div>
  </div>
</template>
<script>
import Header from "../header/header";
import {
  doubleCurrent,
  getTerminalsOfCf
} from "../../assets/js/url";

export default {
  name: "peoplechoice",
  data() {
    return {
      login: "mobile",
      avalibleterminal: "",
      array: [],
      data: Object,
      myset: [],
      searchcontent: "",
      cf_id: "",
      mcuId: "",
      departmentId: "",
      usermessage: Object,
      popshow: false,
      doubleCurrentTermanlId: ""
    };
  },
  components: {
    Header
  },
  activated() {
    this.login = window.sessionStorage.getItem("login");
    this.avalibleterminal = "";
    this.doubleCurrentTermanlId = this.$route.query.doublestreamTerminalId;
    if (this.$route.query.cf_id && this.$route.query.mcuId) {
      this.cf_id = this.$route.query.cf_id;
      this.mcuId = this.$route.query.mcuId;
    } else {
      this.$router.push("/index");
    }
    this.terminalFormat();
  },
  methods: {
    search() {
      if (this.searchcontent) {
        $(".title").css("display", "none");
        $(".contentitem").css("display", "none");
        $(
          ".contentitem:contains(" + this.searchcontent.toLowerCase() + ")"
        ).css("display", "block");
      } else {
        $(".title").css("display", "block");
        $(".contentitem").css("display", "block");
      }
    },
    terminalFormat (){
      let cfparty = JSON.parse(sessionStorage.getItem('_doublestreamCfpary'));
      let newcfparty = [];
      let department = [];
      cfparty.forEach(item=>{
        item.connected && newcfparty.push(item);
        (!department.includes(item.departmentName) && item.connected) && department.push(item.departmentName)
        if(item.partyIdInWeMeet == this.doubleCurrentTermanlId){
          this.avalibleterminal = JSON.stringify(item)
        }
      })
      let data = [];
      department.forEach(item=>{
        let o = {'key':item}
        let arr = [];
        newcfparty.forEach(element=>{
          if(element.departmentName==item){
            arr.push(element)
          }
        })
        o['array'] = arr;
        data.push(o)
      })
      this.array = data
    },
    Radioselect() {
      this.doubleCurrentTermanlId = JSON.parse(
        this.avalibleterminal
      ).partyIdInWeMeet;
    },
    sure() {
      // this.doubleCurrentTermanlId != this.$route.query.doublestreamTerminalId
      if(this.doubleCurrentTermanlId==''){
        this.$toast(this.$t('m.PlsSelectDualTerminal'));
      }else{
        if(this.doubleCurrentTermanlId != this.$route.query.doublestreamTerminalId){
          this.$http
          .post(doubleCurrent, {
            userUUid: window.sessionStorage.getItem("UUID"),
            cfIdInWeMeet: window.sessionStorage.getItem("cfIdInWeMeet"),
            partyIdInWeMeet: this.doubleCurrentTermanlId
          })
          .then(
            res => {
              if (res.data.status === 2000) {
                this.$toast(this.$t('m.DualStreamSenderOK'));
                this.doublestreamshow = false;
              } else {
                this.$toast(this.$t('m.CanceledDualStreamSenderFail'));
                this.doublestreamshow = false;
              }
              this.$router.push({
                path: "/meetingact",
                query: {
                  cf_id: this.cf_id,
                  mcuId: this.mcuId
                }
              });
            },
            err => {
              this.$toast(this.$t('m.ReuestFail'));
            }
          );
        }else{
          this.$router.push({
            path: "/meetingact",
            query: {
              cf_id: this.cf_id,
              mcuId: this.mcuId
            }
          });
        }
      }
    }
  }
  // computed: {
  //   choice() {
  //     return " ";
  //   }
  // }
};
</script>
<style scoped>
.peoplechoice {
  width: 100%;
}

.serch {
  height: 0.4rem;
  line-height: 0.4rem;
  padding: 0 0.15rem;
  font-size: 0.15rem;
  width: 100%;
  position: fixed;
  /* top: 0; */
  left: 0;
  background-color: #fff;
  z-index: 100;
  border-bottom: 1px solid #f2f1f1;
}
.serch_wechat {
  height: 0.52rem;
  line-height: 0.52rem;
  padding: 0 0.15rem;
  font-size: 0.15rem;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fff;
  z-index: 100;
  border-bottom: 1px solid #ddd;
}

/* .choice {
  padding: 0.15rem 0.45rem 0.05rem 0.15rem;
  line-height: 0.3rem;
  padding-top: 1rem;
} */

.serchbox {
  width: 1.9rem;
  height: 0.32rem;
  line-height: 0.32rem;
  display: inline-block;
  border-radius: 5px;
  border: 1px solid #fff;
  /* float: left; */
  margin-right: 0.1rem;
  box-sizing: border-box;
  padding: 0 0.1rem;
}

.searchinput {
  width: 1.4rem;
  height: 0.32rem;
  border: none;
  background-color: transparent;
  outline: none;
  line-height: 0.32rem;
}

i {
  font-size: 0.2rem;
}

.title {
  padding: 0 0.15rem;
  height: 0.28rem;
  background-color: #f8f8f8;
  line-height: 0.28rem;
  font-size: 0.16rem;
  font-weight: bold;
}

.contentitem {
  height: 0.41rem;
  font-size: 0.16rem;
  line-height: 0.41rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.main {
  padding: 0 0 0.5rem;
  padding-top: 1rem;
}
.main_wechat {
  padding: 0 0 0.5rem;
  padding-top: 0.6rem;
}

.radio_wrap {
  width: 100%;
}

.content {
  padding: 0rem 0.15rem;
  line-height: 0.2rem;
}

.bottom {
  width: 100%;
  height: 0.49rem;
  line-height: 0.49rem;
  color: #fff;
  font-size: 0.18rem;
  text-align: center;
  position: fixed;
  bottom: 0px;
  left: 0px;
}

.right {
  position: fixed;
  top: 1rem;
  right: 0px;
  width: 0.38rem;
  background-color: #fff;
  padding: 0;
  height: 75vh;
  overflow-y: scroll;
}

.right span {
  width: 100%;
  line-height: 0.16rem;
  display: inline-block;
  text-align: center;
}

.headerpicwarp {
  display: inline-block;
  width: 0.35rem;
  height: 0.41rem;
  line-height: 0.41rem;
  text-align: center;
  /*float: left;*/
}

.headerpic {
  width: 0.35rem;
  height: 0.35rem;
  vertical-align: middle;
  float: left;
}

.pop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}

.templatepop {
  width: 3rem;
  height: 3.6rem;
  background-color: #fff;
  border-radius: 5px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -1.8rem;
  margin-left: -1.5rem;
  box-sizing: border-box;
  padding: 0.4rem 0;
  font-size: 0.15rem;
}

.popclosex {
  position: absolute;
  top: 0.1rem;
  right: 0.1rem;
}

.leftspan {
  display: inline-block;
  width: 0.5rem;
  text-align: center;
  margin-left: 0.2rem;
}
</style>




// WEBPACK FOOTER //
// src/components/content/doublestream.vue